<template>
  <div class="float-left membership_add_service_width">
    <v-container class="pl-10">
      <p class="display-1 mt-7">부가서비스</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        내 쇼핑몰에 적합한 맞춤 서비스가 가능합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        멤버십 관련 화면 및 기능 설정 관련한 커스텀 제작이 가능합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        샵플러스 고객센터 (0505-277-7770)를 통해 문의하시면 친절하게
        상담해드립니다.
      </p>
      <p class="mt-8 mb-0 title font-weight-light font-weight-bold">
        01. 쇼핑몰 멤버십 화면 커스텀 제작
      </p>
      <p class="mt-2 mb-0 subtitle-2 font-weight-medium">
        PC와 모바일 쇼핑몰에 적합한 멤버십 화면을 쇼핑몰에 맞게 별도 디자인한
        화면으로 제작이 가능합니다.
      </p>

      <p class="mt-8 mb-0 title font-weight-light font-weight-bold">
        02. 쇼핑몰 멤버십 기능 커스텀 제작
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
        쇼핑몰 특성에 맞게 별도 커스텀 기능이 필요한 경우 제작이 가능합니다.
      </p>

      <div class="my-2 mt-8">
        <v-btn depressed large color="primary" @click="additionalServiceApply()"
          >부가서비스 신청하기</v-btn
        >
      </div>
    </v-container>
  </div>
</template>
<style scoped>
.container {
  max-width: 100%;
}
</style>
<script>
export default {
  data: () => ({}),
  methods: {
    additionalServiceApply: function() {
      window.open(
        "https://docs.google.com/forms/d/e/1FAIpQLSeBYyHpdQ471psiid2eGbd2JbAJywahwc7HGeXCJ1UE8DxTrQ/viewform?usp=send_form",
        "_blank"
      );
    },
  },
};
</script>
